module Client.Tenant

open Elmish
open Fable.React
open Fable.React.Props
open Shared.Domain
open System
open Fetch
open Shared

type Msg =
    | Rendered of PageResult
    | FetchError of exn

type Model = 
    { 
        Tenant: string option;
        OutputTest: PageResult option
    }

let renderPage token target =
    FetchRequest.postPromise<ScopedTarget,Domain.PageResult> 
        Urls.GetPage
        (Some 
            [
                RequestProperties.Cache RequestCache.Default
                Fetch.requestHeaders [
                    yield HttpRequestHeaders.ContentType "application/json"
                    yield HttpRequestHeaders.CacheControl "max-age=600" 
                    match token with
                    | None -> ()
                    | Some t -> yield HttpRequestHeaders.Authorization ("Bearer " + t.Token)
                ]
            ] 
        ) 
       target

let postRenderPageCmd tenantName slug (jwt: JWT option) = 
    Cmd.OfPromise.either (renderPage jwt) { Tenant = TenantRef tenantName; Slug = Slug slug } Rendered FetchError

let init tenantName slug = 
    let jwt =
        match BrowserLocalStorage.load<JWT> "user" with
        | Result.Ok t -> Some t
        | Result.Error _ -> None

    {
        Tenant = Some tenantName 
        OutputTest = None
    }, Cmd.batch [ 
        postRenderPageCmd 
            tenantName 
            (if String.IsNullOrWhiteSpace slug then "home" else slug)
            jwt
    ]

let update (msg:Msg) model : Model*Cmd<Msg>* string option =     
    match msg with
    | Rendered output ->
        { model with OutputTest = Some output },[], None
    | FetchError exn ->
        model,[],None

let view model dispatch =
    [
        match model.OutputTest with
        | None -> yield str "Loading..."
        | Some o -> 
            yield div ([ClassName "expanding-child"; Scaffold.appendTheme [] (Scaffold.stackTheme o.Page.Theme)]) (Scaffold.renderPage (Generic o.Page) (Some o.Hierarchy))
    ]
